import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-65eb3371"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-tabs" }
const _hoisted_2 = {
  key: 0,
  class: "tab-title"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "header_title" }
const _hoisted_5 = {
  key: 0,
  class: "is_checked"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "header_item_line"
}
const _hoisted_9 = { class: "ui_tab_wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.tabsTitle.length != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.tabsTitle), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["header-tabs", { gaphOn: _ctx.gaphOn, right: _ctx.right }])
    }, [
      _renderSlot(_ctx.$slots, "back", {}, undefined, true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "header-block",
          key: index
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["header-item", {
						isActive: tab.hash == _ctx.tabsProvider.activeTabHash,
					}]),
            onClick: ($event: any) => (_ctx.selectTab(tab)),
            style: _normalizeStyle({
						paddingRight: !tab.isAllowed ? '50px' : '',
						cursor: tab.isDisabled ? 'default' : 'pointer',
					})
          }, [
            _renderSlot(_ctx.$slots, "header", { data: tab }, () => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(tab.title), 1),
              (tab.isAllowed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                : _createCommentVNode("", true)
            ], true)
          ], 14, _hoisted_3),
          (tab.id != _ctx.tabs.length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 2),
    _createElementVNode("div", _hoisted_9, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}